import {AuthState} from './authState';
import {IAppState} from '../core/redux/IAppState';


type AuthStateAction = {
  type: string,
  payload: AuthState
}

export const authStateAction = (payload: AuthStateAction['payload']): AuthStateAction => ({
  type: 'AUTH_STATE',
  payload: payload,
});

export const authStateReducer = (state: IAppState, action: AuthStateAction): IAppState => {

    if (!action || action.type !== 'AUTH_STATE') return state;

    return {
      ...state,
      auth: action.payload
    };
}